import ContentPostSettingsModalTab from "content/tabs/ContentPostSettingsModalTab"

class ContentCaseStudySnippetTab extends ContentPostSettingsModalTab {
    bindEvents() {
    }

    buildElement() {

        return (
            eotwJSXFactory('div', null, [
                eotwJSXFactory('div', {class: "admin-form__row"}, [
                    eotwJSXFactory('h2', null, ["Snippet"]),
                    eotwJSXFactory('p', null, ["Enter the snippet below. The snippet is used in the article overviews. If you leave this value empty it will be auto generated from the content. The snippet can only be up to 200 characters."])
                ]),
                eotwJSXFactory('div', {className: "admin-form__row"}, [
                    eotwJSXFactory('textarea', {'data-optional': true, className: "admin-form__input admin-form__input--textarea js-snippet"}, [this.contentPost.workingRevision.values.snippet]),
                    eotwJSXFactory('span', {className: "js-inline-validation form__inline-validation"})
                ])
            ])
        );
    }

    getValues() {
        return {
            'snippet': this.$element.find('.js-snippet').val()
        };
    }

    getName() {
        return 'Snippet';
    }
}

export default ContentCaseStudySnippetTab;
